import {Chip} from "@mui/material";

export type PillTone =
    | "systemBlue"
    | "userOrange"
    | "dinBlue"
    | "dexGreen"
    | "openOrange"
    | "doneGreen"
    | "neutral"
    | "prGood"
    | "prWarning"
    | "prBad";

export const pillColors: Record<PillTone, { bg: string; fg: string }> = {
    systemBlue: { bg: "#2F5BEA", fg: "#FFFFFF" }, // azul escuro (Sistema)
    userOrange: { bg: "#F25C2A", fg: "#FFFFFF" }, // laranja (Usuário)
    dinBlue:    { bg: "#6B87FF", fg: "#FFFFFF" }, // azul claro (DIN)
    dexGreen:   { bg: "#18B77E", fg: "#FFFFFF" }, // verde (DEX)
    openOrange: { bg: "#F25C2A", fg: "#FFFFFF" }, // laranja (Em aberto)
    doneGreen:  { bg: "#18B77E", fg: "#FFFFFF" }, // verde (Finalizado)
    neutral:    { bg: "#EEF1F6", fg: "#3A4657" }, // fallback
    prGood:     { bg: "rgba(67, 160, 71, 0.18)",  fg: "#1BB483" }, // PR 70–95 (verde)
    prWarning:  { bg: "rgba(251, 140, 0, 0.18)",  fg: "#F57F17" }, // PR 60–69 ou >95 (âmbar)
    prBad:      { bg: "rgba(244, 67, 54, 0.15)",  fg: "#D32F2F" }, // PR <60 (vermelho)
};

export function Pill({ label, tone }: { label: string; tone: PillTone }) {
    const c = pillColors[tone];

    return (
        <Chip
            label={label}
            size="small"
            sx={{
                height: 24,
                borderRadius: 999,
                bgcolor: c.bg,
                color: c.fg,
                fontWeight: 600,
                fontSize: 12,
                "& .MuiChip-label": {
                    px: 1.25,
                    py: 0,
                },
            }}
        />
    );
}